module.exports = __webpack_public_path__ + "static/img/dd-more.d31ca35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dd/dd-more.png
// module id = UrCi
// module chunks = 1